export default __webpack_public_path__ + "static/media/chris-img.1a5ab37e.png";